import { AppLogo } from '../models/app-logo.model';

export const CHAT_MODULE_LOGO: AppLogo = {
    light: 'assets/shared/images/logo_chat.svg',
    dark: 'assets/shared/images/logo_chat_white.svg',
};

export const XLEARNING_MODULE_LOGO: AppLogo = {
    light: 'assets/shared/images/logo_xlearning.svg',
    dark: 'assets/shared/images/logo_xlearning_white.svg',
};
